import _ from 'lodash'

import {
  LIST_USER_SESSIONS_STARTED,
  LIST_USER_SESSIONS_COMPLETED,
  LIST_USER_SESSIONS_FAILED,

  DELETE_USER_SESSION_STARTED,
  DELETE_USER_SESSION_COMPLETED,
  DELETE_USER_SESSION_FAILED,

  CLEAR_STATES
} from '@/store/types'

import { marshalSession } from '@/utils/marshal'

function getDefaultState () {
  return {
    sessions: [],
    prevPageToken: '',
    nextPageToken: '',
    totalItems: -1,

    loading: false,
    done: false,
    error: undefined,

    deleteLoading: false,
    deleteError: undefined
  }
}

export default {
  namespaced: true,
  modules: {},

  state: getDefaultState(),
  getters: {},

  mutations: {
    [LIST_USER_SESSIONS_STARTED] (state) {
      state.loading = true
    },
    [LIST_USER_SESSIONS_COMPLETED] (state, payload) {
      const {
        sessions,
        previous_page_token: prevPageToken,
        next_page_token: nextPageToken,
        total_size: totalSize
      } = payload
      state.sessions = sessions.map(marshalSession)
      state.prevPageToken = _.cloneDeep(prevPageToken)
      state.nextPageToken = _.cloneDeep(nextPageToken)
      state.totalItems = totalSize

      state.loading = false
      state.done = true
    },
    [LIST_USER_SESSIONS_FAILED] (state, err) {
      state.loading = false
      state.error = err
    },

    [DELETE_USER_SESSION_STARTED] (state) {
      state.deleteLoading = true
    },
    [DELETE_USER_SESSION_COMPLETED] (state, payload) {
      const { sessionId } = payload
      state.sessions = state.sessions.filter(item => item.id !== sessionId)
      state.deleteError = undefined
      state.deleteLoading = false
    },
    [DELETE_USER_SESSION_FAILED] (state, err) {
      state.deleteLoading = false
      state.deleteError = err
    },

    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    async list ({ commit, rootState: { client = undefined, management } }, payload) {
      const { rowsPerPage, pageToken, ascending } = payload
      try {
        commit(LIST_USER_SESSIONS_STARTED)
        const { id: userId } = management.userDetails.user
        const response = await client.managementClient.listSessions(userId, rowsPerPage, pageToken, ascending)
        commit(LIST_USER_SESSIONS_COMPLETED, response)
      } catch (err) {
        commit(LIST_USER_SESSIONS_FAILED, err)
      }
    },
    async delete ({ commit, rootState: { client = undefined } }, sessionId) {
      try {
        commit(DELETE_USER_SESSION_STARTED)
        await client.managementClient.deleteSession(sessionId)
        commit(DELETE_USER_SESSION_COMPLETED, {
          sessionId: sessionId
        })
      } catch (err) {
        commit(DELETE_USER_SESSION_FAILED, err)
      }
    }
  }
}
